import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { DocumentProcessingJobWrapper } from "../model/DocumentProcessingJob";

const DocumentUploadBatchNameListApiService = async (request: {
  employerId: number;
}): Promise<DocumentProcessingJobWrapper> => {
  const url = "/document_processing_jobs";
  const { data } = await axios.get(url, {
    params: {
      employer_id: request.employerId,
    },
  });

  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useDocumentUploadBatchNameListApiService = (request: {
  employerId: number;
}) =>
  useQuery<Promise<any>, AxiosError, any>(
    ["DocumentUploadBatchNameListApiService"],
    async () => {
      const response = await DocumentUploadBatchNameListApiService(request);
      return response.results;
    }
  );
